
export default class Jwt {
  public expiration: Date;
  public id: string;
  public origIat: string;

  public string: string;

  constructor(token: string) {

    this.string = token;

    const parsedToken = this.parseJwt(token);

    this.expiration = new Date(parsedToken.exp * 1000);
    this.id = parsedToken.id;
    this.origIat = parsedToken.orig_iat;
  }

  private parseJwt(token: string) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  }
}

